let baseChars = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
  'ss',
  'aa',
  'ae',
  'ao',
  'au',
  'av',
  'ay',
  'dz',
  'hv',
  'lj',
  'nj',
  'oi',
  'ou',
  'oo',
  'tz',
  'vy',
];

function toBaseChar(c, opts) {
  opts = opts || {};
  if (!('locale' in opts)) opts.locale = 'fr';

  let cOpts = { sensitivity: 'base' };

  //exit early for any non-alphabetical character
  if (c.localeCompare('9', opts.locale, cOpts) <= 0) return opts.nonAlphaChar === undefined ? c : opts.nonAlphaChar;

  for (let i = 0; i < baseChars.length; i++) {
    let baseChar = baseChars[i];

    let comp = c.localeCompare(baseChar, opts.locale, cOpts);
    if (comp === 0) return baseChar;
  }

  return opts.noMatchChar === undefined ? c : opts.noMatchChar;
}

function latinify(str, opts) {
  return str.replace(/[^\w\s\d]/g, (c) => {
    return toBaseChar(c, opts);
  });
}

function fuzzyFilter(searchText, key) {
  let compareString = key.toLowerCase();
  searchText = searchText.toLowerCase();

  // returns -1 if there's no item found
  return compareString.indexOf(searchText);
}

exports.search = (sourceText, data, maxResults = 40) => {
  let results = [];
  sourceText = latinify(sourceText);

  for (let i = 0; i < data.length && results.length < maxResults; i++) {
    // if it doesn't return -1 then we push the item in the results array
    if (fuzzyFilter(sourceText, latinify(data[i].name)) !== -1) {
      results.push(data[i]);
    }
  }

  return results;
};

//export default search
